module.exports = __webpack_public_path__ + "img/UTFREM-20.7cc0d21c.jpg";